// Card-only manifest for the employee-flavoured CRM Contact (ActivityEntityName.ContactEmployee over the shared Contact model).
// Both portals reuse the tenant card verbatim, so `domains` replays the same object.
import { ActivityEntityName, Contact, DomainType } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<Contact> = {
  component: () => import('./entity.card.renderer/contact.employee.entity.card.renderer.component').then(module => module.ContactEmployeeEntityCardRendererComponent),
  resolution: 'if-needed',
  isComplete: value => !!(value.mobile || value.phone || value.workPhone || value.email),
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const contactEmployeeManifest = registerManifest<Contact>({
  entity: ActivityEntityName.ContactEmployee,
  slug: 'contact-employee',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
});
